import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { twMerge as a } from "tailwind-merge";
import { InfoIcon as t } from "../../icons/info-icon.mjs";
const p = ({
  children: n,
  className: o,
  Icon: d = t,
  iconClassName: l,
  textClassName: g,
  style: e = "danger"
}) => /* @__PURE__ */ r(
  "div",
  {
    className: a(
      "[&_a]:underline relative flex flex-wrap items-center gap-1 rounded-lg border p-2",
      e === "danger" && "border-danger bg-danger/10",
      e === "warn" && "border-yellow bg-warning-100",
      o
    ),
    children: /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ r(
        d,
        {
          className: a(
            "shrink-0",
            e === "danger" && "fill-danger",
            e === "warn" && "fill-yellow",
            l
          )
        }
      ),
      /* @__PURE__ */ r(
        "span",
        {
          className: a(
            "flex flex-wrap gap-1 text-sm font-normal",
            e === "danger" && "text-danger",
            e === "warn" && "text-text-primary",
            g
          ),
          children: n
        }
      )
    ] })
  }
);
export {
  p as SectionMessage
};
